import { Reveal, Overline } from "./Reveal";
import { COMPETENCIES, EDUCATION } from "../../data/content";

export const Competencies = () => (
  <section className="relative bg-[#103a2a] py-28 md:py-36">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Overline>07 — Technical Competencies</Overline>
        <div className="mt-10 flex flex-wrap gap-x-8 gap-y-5">
          {COMPETENCIES.map((c, i) => (
            <Reveal key={c} delay={0.03 * i}>
              <span className="font-display text-xl text-[#d4d4d8] transition-colors hover:text-white md:text-2xl">
                {c}
              </span>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-4 lg:col-start-9">
        <Overline>Education</Overline>
        <div className="mt-10 space-y-8">
          {EDUCATION.map((e, i) => (
            <Reveal key={i} delay={0.06 * i}>
              <div className="border-l border-[#c9a24e] pl-5">
                <h3 className="font-display text-lg text-white">{e.title}</h3>
                <p className="mt-1 text-sm text-[#a1a1aa]">{e.school}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
